__turbopack_context__.v({
  "mapViewSwitch": "map-view-switch-module-scss-module__IpsNoG__mapViewSwitch",
  "mapViewSwitch_mapIcon": "map-view-switch-module-scss-module__IpsNoG__mapViewSwitch_mapIcon",
});
